import { render, staticRenderFns } from "./NumlistIcon.vue?vue&type=template&id=32964dcc&"
import script from "./NumlistIcon.vue?vue&type=script&lang=js&"
export * from "./NumlistIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports